package com.shadowings.gero.data.lessons.chapter14

import com.shadowings.gero.data.lessons.DistractorPool
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.lessons.buildAdverbialSentenceSync
import com.shadowings.gero.data.lessons.buildImperfectiveSentenceSync
import com.shadowings.gero.data.lessons.chapter11.buildRichestPseudoverbalSentence
import com.shadowings.gero.data.lessons.chapter11.buildWordBankFromWords
import com.shadowings.gero.data.lessons.chapter13.HrComplementType
import com.shadowings.gero.data.lessons.chapter13.getRandomHrComplementSentence
import com.shadowings.gero.data.lessons.chapter13.hasHrComplementCandidate
import com.shadowings.gero.data.lessons.distinctBaseWordCount
import com.shadowings.gero.data.repository.DatabaseRepositoryImpl
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.MultiPressContent
import com.shadowings.gero.domain.model.MultiPressPair
import com.shadowings.gero.domain.model.PhoneticKeyboardContent
import com.shadowings.gero.domain.model.TextTranslationContent
import com.shadowings.gero.domain.model.WordSelectionContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_rieccolo_di_nuovo_1
import gero.composeapp.generated.resources.exp_content_rieccolo_di_nuovo_10
import gero.composeapp.generated.resources.exp_content_rieccolo_di_nuovo_11
import gero.composeapp.generated.resources.exp_content_rieccolo_di_nuovo_12
import gero.composeapp.generated.resources.exp_content_rieccolo_di_nuovo_13
import gero.composeapp.generated.resources.exp_content_rieccolo_di_nuovo_14
import gero.composeapp.generated.resources.exp_content_rieccolo_di_nuovo_15
import gero.composeapp.generated.resources.exp_content_rieccolo_di_nuovo_16
import gero.composeapp.generated.resources.exp_content_rieccolo_di_nuovo_17
import gero.composeapp.generated.resources.exp_content_rieccolo_di_nuovo_18
import gero.composeapp.generated.resources.exp_content_rieccolo_di_nuovo_2
import gero.composeapp.generated.resources.exp_content_rieccolo_di_nuovo_3
import gero.composeapp.generated.resources.exp_content_rieccolo_di_nuovo_4
import gero.composeapp.generated.resources.exp_content_rieccolo_di_nuovo_5
import gero.composeapp.generated.resources.exp_content_rieccolo_di_nuovo_6
import gero.composeapp.generated.resources.exp_content_rieccolo_di_nuovo_7
import gero.composeapp.generated.resources.exp_content_rieccolo_di_nuovo_8
import gero.composeapp.generated.resources.exp_content_rieccolo_di_nuovo_9
import gero.composeapp.generated.resources.exp_title_rieccolo_di_nuovo
import gero.composeapp.generated.resources.question_type_multipress
import kotlin.random.Random

private const val FIRST_CLAUSE_GARDINER =
    "M17-G43-A1-D2h2:Z1-G17-D36:N29-M36:D21-Q3w0.5-G40-X1:N9:Z2"
private const val SECOND_CLAUSE_GARDINER = "D35-U2:D4-A1-W19-X1:Z4-O34:D21-G43-Q3:N35"
private const val FULL_SENTENCE_GARDINER =
    "M17-G43-A1-D2h2:Z1-G17-D36:N29-M36:D21-Q3w0.5-G40-X1:N9:Z2-D35-U2:D4-A1-W19-X1:Z4-O34:D21-G43-Q3:N35"

fun getRieccoloDiNuovoContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_rieccolo_di_nuovo,
            content = Res.string.exp_content_rieccolo_di_nuovo_1,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = FULL_SENTENCE_GARDINER, rtl = false, cart = false, size = 48.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_rieccolo_di_nuovo,
            content = Res.string.exp_content_rieccolo_di_nuovo_2,
            face = Faces.Idle,
            character = Characters.Nilo,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = FIRST_CLAUSE_GARDINER, rtl = false, cart = false, size = 56.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_rieccolo_di_nuovo,
            content = Res.string.exp_content_rieccolo_di_nuovo_3,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_rieccolo_di_nuovo,
            content = Res.string.exp_content_rieccolo_di_nuovo_4,
            face = Faces.Idle,
            character = Characters.Nilo,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = SECOND_CLAUSE_GARDINER, rtl = false, cart = false, size = 56.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_rieccolo_di_nuovo,
            content = Res.string.exp_content_rieccolo_di_nuovo_5,
            face = Faces.Surprised,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_rieccolo_di_nuovo,
            content = Res.string.exp_content_rieccolo_di_nuovo_6,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_rieccolo_di_nuovo,
            content = Res.string.exp_content_rieccolo_di_nuovo_7,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_rieccolo_di_nuovo,
            content = Res.string.exp_content_rieccolo_di_nuovo_8,
            face = Faces.Doubt,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_rieccolo_di_nuovo,
            content = Res.string.exp_content_rieccolo_di_nuovo_9,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_rieccolo_di_nuovo,
            content = Res.string.exp_content_rieccolo_di_nuovo_10,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_rieccolo_di_nuovo,
            content = Res.string.exp_content_rieccolo_di_nuovo_11,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_rieccolo_di_nuovo,
            content = Res.string.exp_content_rieccolo_di_nuovo_12,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_rieccolo_di_nuovo,
            content = Res.string.exp_content_rieccolo_di_nuovo_13,
            face = Faces.Surprised,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_rieccolo_di_nuovo,
            content = Res.string.exp_content_rieccolo_di_nuovo_14,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_rieccolo_di_nuovo,
            content = Res.string.exp_content_rieccolo_di_nuovo_15,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_rieccolo_di_nuovo,
            content = Res.string.exp_content_rieccolo_di_nuovo_16,
            face = Faces.Idle,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_rieccolo_di_nuovo,
            content = Res.string.exp_content_rieccolo_di_nuovo_17,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_rieccolo_di_nuovo,
            content = Res.string.exp_content_rieccolo_di_nuovo_18,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
    )
}

private data class RieccoloSentence(
    val hieroglyphs: String,
    val transliteration: String,
    val translation: String,
    val isNegative: Boolean,
    val thisSubject: Boolean
)

private enum class RieccoloQuizKind {
    WORD_BANK,
    TEXT_TRANSLATION,
    PHONETIC_KEYBOARD
}

fun getRieccoloDiNuovoQuizContent(
    hiero: List<Hiero> = emptyList(),
    words: List<Word> = emptyList(),
    verbs: List<Verb> = emptyList(),
    languageCode: String = "",
    verbSentences: List<SentenceOptions> = emptyList(),
    random: Random = Random,
    // IL_DIMOSTRATIVO_PN reuses this generator with every sentence built
    // around a demonstrative subject (pn/tn/nn) instead of a random mix.
    demonstrativeOnly: Boolean = false
): List<IQuizContent> {
    val effectiveWords = words.ifEmpty { DatabaseRepositoryImpl.words }
    val effectiveVerbs = verbs.ifEmpty { DatabaseRepositoryImpl.verbs }
    val effectiveVerbSentences = verbSentences.ifEmpty { DatabaseRepositoryImpl.verbSentences }
    val effectiveAdverbials = DatabaseRepositoryImpl.adverbialSentences
    val pool = effectiveVerbSentences.filter { it.verbs.isNotEmpty() }
        .ifEmpty { DatabaseRepositoryImpl.verbSentences.filter { it.verbs.isNotEmpty() } }

    if (effectiveWords.isEmpty() || effectiveVerbs.isEmpty() || effectiveVerbSentences.isEmpty() || effectiveAdverbials.isEmpty() || pool.isEmpty()) {
        return emptyList()
    }

    val seenTranslations = mutableSetOf<String>()

    // 1) 3 VSO sentences with random parameters (thisSubject, isNegative, 0..2 objects, 1..2 subjects)
    val vsoSentences = mutableListOf<RieccoloSentence>()
    val vsoNegFlags = listOf(true, false, random.nextBoolean()).shuffled(random)
    val vsoThisFlags = if (demonstrativeOnly) List(3) { true } else listOf(true, false, random.nextBoolean()).shuffled(random)
    for (i in 0 until 3) {
        val isNeg = vsoNegFlags[i]
        val thisSubj = vsoThisFlags[i]
        var chosen: RieccoloSentence? = null
        for (attempt in 0 until 10) {
            val candidateSoggetti = if (random.nextBoolean() && effectiveVerbSentences.any {
                    distinctBaseWordCount(
                        it.subjects,
                        effectiveWords
                    ) >= 2
                }) 2 else 1
            val candidateRows = effectiveVerbSentences.filter {
                distinctBaseWordCount(
                    it.subjects,
                    effectiveWords
                ) >= candidateSoggetti
            }
            val maxObjects =
                candidateRows.maxOfOrNull { distinctBaseWordCount(it.objects, effectiveWords) } ?: 0
            val possibleOggetti = (0..minOf(2, maxObjects)).toList().ifEmpty { listOf(0) }
            val candidateOggetti = possibleOggetti.random(random)

            val res = buildImperfectiveSentenceSync(
                soggettiCount = candidateSoggetti,
                oggettiCount = candidateOggetti,
                random = random,
                verbSentences = effectiveVerbSentences,
                words = effectiveWords,
                verbs = effectiveVerbs,
                isNegative = isNeg,
                thisSubject = thisSubj
            )
            val translation = when (languageCode) {
                "it" -> res.translationIt
                "de" -> res.translationDe
                "es" -> res.translationEs
                "fr" -> res.translationFr
                else -> res.translationEn
            }
            val item =
                RieccoloSentence(res.hieroglyphs, res.transliteration, translation, isNeg, thisSubj)
            if (translation !in seenTranslations || attempt == 9) {
                seenTranslations.add(translation)
                chosen = item
                break
            }
        }
        chosen?.let { vsoSentences.add(it) }
    }

    // 2) 3 Adverbial sentences with random parameters (thisSubject, isNegative, 1..2 subjects, withParticleIw)
    val advSentences = mutableListOf<RieccoloSentence>()
    val advNegFlags = listOf(true, false, random.nextBoolean()).shuffled(random)
    val advThisFlags = if (demonstrativeOnly) List(3) { true } else listOf(true, false, random.nextBoolean()).shuffled(random)
    for (i in 0 until 3) {
        val isNeg = advNegFlags[i]
        val thisSubj = advThisFlags[i]
        var chosen: RieccoloSentence? = null
        for (attempt in 0 until 10) {
            val maxAdvSubjects = effectiveAdverbials.maxOfOrNull { it.subjects.size } ?: 1
            val soggettiCount = if (maxAdvSubjects >= 2 && random.nextBoolean()) 2 else 1
            val res = buildAdverbialSentenceSync(
                soggettiCount = soggettiCount,
                withParticleIw = true,
                random = random,
                words = effectiveWords,
                adverbialSentences = effectiveAdverbials,
                isNegative = isNeg,
                thisSubject = thisSubj
            )
            val translation = when (languageCode) {
                "it" -> res.translationIt
                "de" -> res.translationDe
                "es" -> res.translationEs
                "fr" -> res.translationFr
                else -> res.translationEn
            }
            val item =
                RieccoloSentence(res.hieroglyphs, res.transliteration, translation, isNeg, thisSubj)
            if (translation !in seenTranslations || attempt == 9) {
                seenTranslations.add(translation)
                chosen = item
                break
            }
        }
        chosen?.let { advSentences.add(it) }
    }

    // 3) 3 Pseudoverbal sentences with random parameters (direct/indirect genitive complex object, ḥr place complement, thisSubject, isNegative, isPronominal)
    val pseudoSentences = mutableListOf<RieccoloSentence>()
    val pseudoNegFlags = listOf(true, false, random.nextBoolean()).shuffled(random)
    val pseudoThisFlags = if (demonstrativeOnly) List(3) { true } else listOf(true, false, random.nextBoolean()).shuffled(random)
    var usedHr = false
    for (i in 0 until 3) {
        val isNeg = pseudoNegFlags[i]
        val thisSubj = pseudoThisFlags[i]
        var chosen: RieccoloSentence? = null
        for (attempt in 0 until 10) {
            val canUseHr = !isNeg && !thisSubj && !usedHr && hasHrComplementCandidate(
                HrComplementType.PLACE,
                effectiveVerbs,
                effectiveVerbSentences
            )
            val shouldPickHr = canUseHr && (attempt == 0 || random.nextBoolean())
            val item = if (shouldPickHr) {
                val s = getRandomHrComplementSentence(
                    type = HrComplementType.PLACE,
                    verbs = effectiveVerbs,
                    words = effectiveWords,
                    isPronominal = random.nextBoolean(),
                    random = random,
                    verbSentences = effectiveVerbSentences
                )
                usedHr = true
                RieccoloSentence(
                    hieroglyphs = s.hieroglyphs,
                    transliteration = s.transliteration,
                    translation = s.getTranslation(languageCode),
                    isNegative = false,
                    thisSubject = false
                )
            } else {
                val isPronominal = random.nextBoolean()
                val res = buildRichestPseudoverbalSentence(
                    pool = pool,
                    verbs = effectiveVerbs,
                    words = effectiveWords,
                    isPronominal = isPronominal,
                    languageCode = languageCode,
                    random = random,
                    isNegative = isNeg,
                    thisSubject = thisSubj
                )
                RieccoloSentence(
                    res.hieroglyphs,
                    res.transliteration,
                    res.translation,
                    isNeg,
                    thisSubj
                )
            }
            if (item.translation !in seenTranslations || attempt == 9) {
                seenTranslations.add(item.translation)
                chosen = item
                break
            }
        }
        chosen?.let { pseudoSentences.add(it) }
    }

    val allSentences = (vsoSentences + advSentences + pseudoSentences).shuffled(random)

    // Quiz types for the 9 sentences: exactly 1 PhoneticKeyboardContent, 4 WordSelectionContent, 4 TextTranslationContent
    val quizTypes = (listOf(RieccoloQuizKind.PHONETIC_KEYBOARD) +
            List(4) { RieccoloQuizKind.WORD_BANK } +
            List(4) { RieccoloQuizKind.TEXT_TRANSLATION }).shuffled(random)

    val sentenceQuizzes = allSentences.zip(quizTypes).map { (sentence, type) ->
        when (type) {
            RieccoloQuizKind.PHONETIC_KEYBOARD -> {
                PhoneticKeyboardContent(
                    sentence = sentence.hieroglyphs,
                    info = "${sentence.transliteration} -> ${sentence.translation}",
                    reading = sentence.transliteration.map { it.toString() },
                    isProperName = false,
                    canRotate = false
                )
            }

            RieccoloQuizKind.TEXT_TRANSLATION -> {
                TextTranslationContent(
                    hieroglyphs = sentence.hieroglyphs,
                    correctPhrase = sentence.translation,
                    transliteration = sentence.transliteration
                )
            }

            RieccoloQuizKind.WORD_BANK -> {
                val baseBank = buildWordBankFromWords(
                    correctPhrase = sentence.translation,
                    words = effectiveWords,
                    verbs = effectiveVerbs,
                    languageCode = languageCode,
                    random = random
                )
                val negDistractors = if (!sentence.isNegative) {
                    when (languageCode) {
                        "it" -> listOf("non")
                        "de" -> listOf("nicht")
                        "es" -> listOf("no")
                        "fr" -> listOf("ne", "pas")
                        else -> listOf("not")
                    }
                } else emptyList()
                val demDistractors = if (!sentence.thisSubject) {
                    when (languageCode) {
                        "it" -> listOf("questo", "questa")
                        "de" -> listOf("dieser", "diese")
                        "es" -> listOf("este", "esta")
                        "fr" -> listOf("ce", "cette")
                        else -> listOf("this", "these")
                    }
                } else emptyList()
                val wordBank = (baseBank + negDistractors + demDistractors).shuffled(random)
                WordSelectionContent(
                    hieroglyphs = sentence.hieroglyphs,
                    correctPhrase = sentence.translation,
                    words = wordBank,
                    transliteration = sentence.transliteration
                )
            }
        }
    }

    // 2 MultiPress matching questions (4 pairs each = 8 distinct vocabulary words)
    val compendioWords = DistractorPool.words(effectiveWords)
        .filter { it.gardiner.isNotBlank() && it.getMeaning(languageCode).isNotBlank() }
        .let { list ->
            val compOnly = list.filter { it.showInCompendio }
            if (compOnly.size >= 8) compOnly else list
        }
        .distinctBy { it.getMeaning(languageCode).lowercase().trim() }
        .shuffled(random)

    val matchingQuizzes = if (compendioWords.size >= 8) {
        listOf(
            MultiPressContent(
                pairs = compendioWords.subList(0, 4).map {
                    MultiPressPair(hieroglyphs = it.gardiner, meaning = it.getMeaning(languageCode))
                },
                prompt = Res.string.question_type_multipress
            ),
            MultiPressContent(
                pairs = compendioWords.subList(4, 8).map {
                    MultiPressPair(hieroglyphs = it.gardiner, meaning = it.getMeaning(languageCode))
                },
                prompt = Res.string.question_type_multipress
            )
        )
    } else {
        emptyList()
    }

    return (sentenceQuizzes + matchingQuizzes).shuffled(random)
}
